import React from 'react';

import { CheckIcon, CheckboxLabel, CheckboxWrapper } from './MyCheckbox.styles';
import activeIcon from './activeIcon.svg';
import inactiveIcon from './inactiveIcon.svg';

const MyCheckbox = ({ selected, onClick, uuid, label }) => {
  const handleClick = () => {
    onClick(uuid);
  };

  return (
    <CheckboxWrapper selected={selected} onClick={handleClick}>
      <CheckIcon src={selected ? activeIcon : inactiveIcon} alt="Checkbox Icon" />
      {label && <CheckboxLabel selected={selected}>{label}</CheckboxLabel>}
    </CheckboxWrapper>
  );
};

export default MyCheckbox;
